<div class="d-flex flex-row justify-content-between align-items-center">
	<h1>Widget Details</h1>	
</div>
<hr />

<p-table 
    #dt
    [columns]="visibleColumns"
    [value]="list"
    dataKey="widgetId"
    [rowHover]="true"
    [rows]="50"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
    [loading]="isLoading"
    [paginator]="true"
    [currentPageReportTemplate]="!isMobile ? 'Showing {first} to {last} of {totalRecords} entries' : ''"
    [filterDelay]="500"
    [size]="'large'"
    [stripedRows]="!isMobile"  
    sortField="id"
    selectionMode="single"    
    [globalFilterFields]="searchColumns"
    [dt]="tableDts"
    [scrollable]="true"
    scrollHeight="650px"
>

    <ng-template #caption>
        <div class="d-flex flex-wrap align-items-center gap">
            <div>
                @if (!isMobile) {
                    <p-multiselect 
                        class="pl-1"
                        display="chip" 
                        [options]="availableColumns" 
                        [(ngModel)]="visibleColumns" 
                        optionLabel="header" 
                        selectedItemsLabel="Show / Hide" 
                        [style]="{ 'min-width': '100px' }" 
                        placeholder="Choose Columns" 
                        (ngModelChange)='columnChange($event)'
                    />
                }
            </div>

            <div 
                class="d-flex"
                [ngClass]="!isMobile ? 'ml-auto' : ''"
            >
                <p-iconfield 
                    iconPosition="right" 
                    class="ml-auto"
                >                    
                    <p-inputicon>
                        <i class="pi pi-search pl-2"></i>
                    </p-inputicon>
                    <input 
                        #searchValue
                        pInputText 
                        type="text" 
                        (input)="dt.filterGlobal($event.target.value, 'contains')" 
                        placeholder="Search..." 
                    />
                </p-iconfield>
            </div>
        </div>
    </ng-template>

    @if (!isMobile) {
        <ng-template 
            #header 
            let-columns
        >
            <tr>
                @for (col of columns; track col.field; let i = $index) {
                    <th 
                        [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                        [class]="col?.cellClass"
                    >
                        @if (col?.headerTooltip != "") {
                            <span 
                                container='body' 
                                class="ignoreTooltipStyle" 
                                [ngbTooltip]="$safeNavigationMigration(col?.headerTooltip)"
                            >{{ col?.header }}</span>
                        } @else { {{ col?.header }} }
                        @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                    </th>
                }
            </tr>
        </ng-template>

        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr 
                [pSelectableRow]="row" 
                (click)="redirectToEdit(row)"
            >
                @for (col of columns; track col) {
                    <td [class]="col?.cellClass">
                         {{ row[col?.field] }} 
                    </td>
                }
            </tr>
        </ng-template>
    } @else {
        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr
                [pSelectableRow]="row" 
                (click)="redirectToEdit(row)" 
            >
                <td 
                    class="mobile-card-padding" 
                    style="border: none"
                >
                    <div class="d-flex flex-column w-100 p-0 list-card">
                        <div class="d-flex flex-row justify-content-between align-items-center w-100 list-header">
                            <div class="unique-field">
                                <div class="p-2 d-flex flex-row flex-wrap">
                                    <h4>{{ row.name }}</h4>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="list-field">
                                <div class="card-list-item">
                                    <p>Description</p>
                                    <h6>{{ row.description }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    }

    <ng-template #emptymessage>
        <tr>
            <td 
                colspan="999" 
                class="text-center"
            >No records found.</td>
        </tr>
    </ng-template>
</p-table>
